import invoiceApi from 'api/invoiceApi'
import { MESSAGE_SUCCESS } from 'general/constants/AppConstants'
import PreferenceKeys from 'general/constants/PreferenceKeys'
import ToastHelper from 'general/helpers/ToastHelper'
import Utils, { setTaxCode } from 'general/utils/Utils'

const updateInvoice = async (
  values,
  submitAction,
  invoiceProduct,
  company,
  dispatch,
  setAppSpinning,
  invoiceId,
  buyerInfoExtendFields,
  navigate,
  isFromPOS,
  isDeliveryBill,
  handleIssueFromPos,
  sendInvoiceModal,
  resetButtonSaveAndSign = () => {},
) => {
  let signingMethod = company?.activeSigningMethod
  //   let invoiceProduct = [...tableData];
  if (values.customerTaxCode) {
    if (!(values.customerCompanyName && values.customerFullAddress)) {
      ToastHelper.showError(
        'Tên đơn vị và dịa chỉ người mua không được để trống khi có MST người mua',
      )
      return
    }
  }
  // item cuối không có name thì không gửi lên api
  if (invoiceProduct[invoiceProduct.length - 1].name === '') {
    invoiceProduct.pop()
  }
  const params = {
    ...values,
    invoiceProduct,
    buyerInfoExtendFields,
    total: parseFloat(values.total),
    totalAfterTax: parseFloat(values.totalAfterTax),
    taxMoney: parseFloat(values.taxMoney),
  }
  const navigateHandler = () => {
    if (isFromPOS)
      return '/hoa-don-dau-ra/hoa-don/may-tinh-tien/danh-sach-hoa-don'
    if (isDeliveryBill) return '/hoa-don-dau-ra/hoa-don/phieu-xuat-kho'
    return '/hoa-don-dau-ra/hoa-don/danh-sach-hoa-don'
  }
  switch (submitAction) {
    case 'SaveNoNavigate':
      try {
        const res = await invoiceApi.update(invoiceId, params)
        if (res) {
          if (res.result === 'success') {
            ToastHelper.showSuccess('Cập nhật hoá đơn nháp thành công')
            // navigate(
            //   isFromPOS
            //     ? '/hoa-don-dau-ra/hoa-don/may-tinh-tien/danh-sach-hoa-don'
            //     : '/hoa-don-dau-ra/hoa-don/danh-sach-hoa-don',
            // )
            sendInvoiceModal()
          }
        }
      } catch (err) {
        console.log(err)
        ToastHelper.showError('Cập nhật hoá đơn thất bại')
      } finally {
        resetButtonSaveAndSign()
      }
      break
    case 'Save': {
      try {
        const res = await invoiceApi.update(invoiceId, params)
        if (res) {
          if (res.result === 'success') {
            ToastHelper.showSuccess('Cập nhật hoá đơn nháp thành công')
            navigate(navigateHandler())
          }
        }
      } catch (err) {
        console.log(err)
        ToastHelper.showError('Cập nhật hoá đơn thất bại')
      } finally {
        resetButtonSaveAndSign()
      }
      break
    }

    case 'SaveAndSign': {
      try {
        const res = await invoiceApi.update(invoiceId, params)
        if (res) {
          if (res.result === 'success') {
            ToastHelper.showSuccess('Cập nhật hoá đơn nháp thành công')

            /* Trường hợp phát hành hóa đơn mtt */
            if (isFromPOS) {
              handleIssueFromPos(invoiceId)
              return
            }

            /* Trường hợp không phải hóa đơn mtt */
            // let accessToken = localStorage.getItem(PreferenceKeys.accessToken)
            // navigate(navigateHandler())
            // const urlSchema = `${process.env.REACT_APP_BASE_URL_SCHEMA}${accessToken},${company?.taxCode},${invoiceId}`
            // Utils.openToolSignInvoice(
            //   urlSchema,
            //   accessToken,
            //   dispatch,
            //   setAppSpinning,
            // )
            if (signingMethod == 'HSM') {
              const hsmInvoicesSignParams = {
                invoiceIds: [invoiceId],
              }
              if (isDeliveryBill) hsmInvoicesSignParams.classify = 'PXK'
              let _res = await invoiceApi.hsmInvoicesSign(hsmInvoicesSignParams)
              if (_res.data) _res = _res.data

              // Kí thành công
              if (
                !!_res?.successSignInvoices?.find(
                  ({ invoiceId: _invoiceId }) => _invoiceId == invoiceId,
                )
              ) {
                ToastHelper.showSuccess(MESSAGE_SUCCESS.ISSUED_INVOICE)
                navigate(navigateHandler())
                return
              }
              // Kí thất bại
              ToastHelper.showError(_res?.errorSignInvoices?.at(0)?.reason)
            } else {
              let accessToken = localStorage.getItem(PreferenceKeys.accessToken)
              const taxCode = setTaxCode(company?.taxCode, company)
              const urlSchema = `${process.env.REACT_APP_BASE_URL_SCHEMA}${accessToken},${taxCode},${invoiceId}${isDeliveryBill ? ',PXK' : ''}`
              Utils.openToolSignInvoice(
                urlSchema,
                accessToken,
                dispatch,
                setAppSpinning,
              )
              navigate(navigateHandler())
            }
          } else {
            ToastHelper.showSuccess('Cập nhật hoá đơn hoá đơn thất bại')
          }
        }
      } catch (err) {
        console.log(err)
        ToastHelper.showError('Cập nhật hoá đơn hoá đơn thất bại')
      } finally {
        resetButtonSaveAndSign()
      }
      break
    }

    //huy
    case 'Preview': {
      dispatch(setAppSpinning(true))
      var res
      try {
        res = await invoiceApi.exportInvoice({ ...params })
      } catch (e) {
        console.log(e)
      } finally {
        resetButtonSaveAndSign()
        dispatch(setAppSpinning(false))
      }

      const fileURL = `${process.env.REACT_APP_BASE_URL}${res?.fileURL}`
      window.open(fileURL, '_blank')
      break
    }

    default:
      return null
  }
}

export default updateInvoice
